(function ($) {
  $(document).on('shown.bs.collapse', function(event) {
    if ('undefined' === typeof lazyLoadInstance || 'undefined' === typeof lazyLoadInstance.update) {
      return;
    }
    lazyLoadInstance.update();
  })
})(window.jQuery);
